import { render, staticRenderFns } from "./ListTahun.vue?vue&type=template&id=7bd5677a&"
import script from "./ListTahun.vue?vue&type=script&lang=js&"
export * from "./ListTahun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports